const convertToSlug = (string = '') => string.toLowerCase().replace(/ /g,'-').replace(/[^\w-]+/g,'');

export default convertToSlug
